import React, { FC } from 'react';
import MuiInputLabel, { InputLabelProps as MuiInputLabelProps } from '@mui/material/InputLabel';
import { BpDesignSystem } from '../../types';

export type FormLabelProps = BpDesignSystem.PropsWithChildren<MuiInputLabelProps>;

export const FormLabel: FC<FormLabelProps> = ({
  required = false,
  htmlFor,
  disableAnimation = true,
  style,
  children,
  className,
  error,
  dataTest,
  shrink = true,
  ...rest
}) => {
  if (!children) {
    return null;
  }
  return (
    <MuiInputLabel
      disableAnimation={disableAnimation}
      required={required}
      error={error}
      className={className}
      htmlFor={htmlFor}
      style={style}
      data-test={dataTest}
      shrink={shrink}
      {...rest}
    >
      {children}
    </MuiInputLabel>
  );
};
